import { render } from "./ColonyTradeRow.vue?vue&type=template&id=5b3a6f33&ts=true"
import script from "./ColonyTradeRow.vue?vue&type=script&lang=ts"
export * from "./ColonyTradeRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__